export default __webpack_public_path__ + "static/media/people.cb088a91.webp";